import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(swal);
const swalWithBootstrapButtons = MySwal.mixin({
    customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
    },
    buttonsStyling: false,
    heightAuto: false
});

export function mostraAlerta(mensaje, icono, foco) {

    MySwal.fire({

        title: mensaje,
        icon: icono, //success, info, error, warning
        confirmButtonText: 'Aceptar',
        customClass: {
            confirmButton: 'btn-primary', // Clases de Bootstrap para el botón de confirmación
        },
    });
}

export function mostraAlertaOk(mensaje, icono, foco) {
    MySwal.fire({

        title: mensaje,
        icon: 'success', //success, info, error, warning
        confirmButtonText: 'Aceptar',
        showConfirmButton: false,
        timer: 1500
    });
}
export function mostraAlertaPregunta(accion, mensaje, icono, foco) {
    MySwal.fire({

        title: mensaje,
        icon: 'question', //success, info, error, warning
        confirmButtonText: 'Si',
        showConfirmButton: true,
        cancelButtonText: 'No',
        showCancelButton: true,
    }).then((re)=>{
        if(re.isConfirmed){
            accion(true)
        }else{
            accion(false)
        }
    });
}
export function mostraAlertaPreguntaFacturaccion(accion, mensaje, icono, foco) {
    MySwal.fire({
        title: mensaje,
        icon: icono || 'question',
        confirmButtonText: 'Factura',
        denyButtonText: 'Consumidor Final',
        showConfirmButton: true,
        showDenyButton: true,
        showCancelButton: false,
        focusConfirm: true,
        heightAuto: false,
        scrollbarPadding: false
    }).then((result) => {

        if (result.isConfirmed) {
            // Flujo 1: FACTURA -> Contado (FA) o Crédito (CR)
            MySwal.fire({
                title: '¿La Factura es al Contado o al Crédito?',
                icon: 'question',
                confirmButtonText: 'Contado',
                denyButtonText: 'Crédito',
                showConfirmButton: true,
                showDenyButton: true,
                showCancelButton: false,
                focusConfirm: true,
                heightAuto: false,
                scrollbarPadding: false,
            }).then((result2) => {
                if (result2.isConfirmed) {
                    accion("FA", 'FACTURA'); // Factura Contado: Enviamos 'FACTURA'
                } else if (result2.isDenied) {
                    accion("CR", 'FACTURA'); // Factura Crédito: Enviamos 'FACTURA'
                }
            });

        } else if (result.isDenied) {
            // Flujo 2: RECIBO -> Contado (RE) o Crédito (CR)
            MySwal.fire({
                title: '¿El Recibo es al Contado o al Crédito?',
                icon: 'question',
                confirmButtonText: 'Contado',
                denyButtonText: 'Crédito',
                showConfirmButton: true,
                showDenyButton: true,
                showCancelButton: false,
                focusConfirm: true,
                heightAuto: false,
                scrollbarPadding: false,
            }).then((result2) => {
                if (result2.isConfirmed) {
                    accion("RE", 'RECIBO'); // Recibo Contado: Enviamos 'RECIBO'
                } else if (result2.isDenied) {
                    accion("CR", 'RECIBO'); // Recibo Crédito: Enviamos 'RECIBO'
                }
            });
        }
    });
}
export function mostraAlertaError(mensaje, icono, foco) {
    MySwal.fire({

        title: mensaje,
        icon: 'error', //success, info, error, warning
        confirmButtonText: 'Aceptar',
        showConfirmButton: false,
        timer: 3000
    });
}
export function mostraAlertaWarning(mensaje, icono, foco) {
    MySwal.fire({

        title: mensaje,
        icon: 'warning', //success, info, error, warning
        confirmButtonText: 'Aceptar',
        showConfirmButton: false,
        timer: 3000
    });
}

export function mostraAlertaModificar(titulo, mensaje, peticion) {
    swalWithBootstrapButtons.fire({
        title: titulo,
        text: mensaje,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Modificar',
        cancelButtonText: 'Cancel!',
        reverseButtons: true
    }).then((result) => {
        if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
                'Modificado',
                'Registro Modificado',
                'success'
            )
        } else if (
            /* Read more about handling dismissals below */
            result.dismiss === swal.DismissReason.cancel
        ) {
            swalWithBootstrapButtons.fire(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
            )
        }
    });
}

export function mostraAlertaPersonalizada({
    titulo = "¿Estás seguro?",
    mensaje = "",
    icono = "question",
    textoConfirmacion = "Aceptar",
    textoCancelacion = "Cancelar",
    accion,
    foco = true
}) {
    MySwal.fire({
        title: titulo,
        text: mensaje,
        icon: icono, // success, info, error, warning, question
        confirmButtonText: textoConfirmacion,
        cancelButtonText: textoCancelacion,
        showConfirmButton: true,
        showCancelButton: true,
        focusCancel: !foco,
    }).then((resultado) => {
        if (resultado.isConfirmed) {
            accion(true); // Acción para confirmar
        } else {
            accion(false); // Acción para cancelar
        }
    });
}

export function mostrarAlertaLoading(mensaje = "Guardando datos...", texto = "Por favor, espere un momento.") {
  MySwal.fire({
    title: mensaje,
    text: texto,
    allowOutsideClick: false,
    didOpen: () => {
      MySwal.showLoading();
    }
  });
}

/**
 * Actualiza el texto de un indicador de carga ya abierto, sin cerrarlo ni
 * perder el spinner. Se usa para informar el avance de una carga por lotes.
 */
export function actualizarAlertaLoading(texto) {
  const contenedor = MySwal.getHtmlContainer();
  if (contenedor) {
    contenedor.textContent = texto;
  }
}

// Cerrar alerta
export function cerrarAlerta() {
  try {
    MySwal.close();
  } catch (e) {
    console.warn("Error al invocar MySwal.close():", e);
  }
  setTimeout(() => {
    const contenedor = document.querySelector('.swal2-container');
    if (contenedor) {
      contenedor.remove();
    }
    if (typeof document !== 'undefined' && document.body && document.body.classList.contains('swal2-shown')) {
      document.body.classList.remove('swal2-shown', 'swal2-height-auto');
    }
  }, 100);
}

function onfocus(foco) {
    if (foco !== '') {
        document.getElementById(foco).focus();
    }
}